import React, { useState, useEffect } from 'react'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import { connect } from 'react-redux'
import RangePicker from '../../../components/RangePicker'
import {
    applyCurveFilter,
    changeMultiplyIntensity,
    resetMultiply,
} from '../../../redux/tools/actions'
import classnames from 'classnames'

const MiniEditor = (props) => {
    const [multiply, setMultiply] = useState(0.8)

    useEffect(() => {
        setMultiply(props.multiply)
    }, [props.multiply])

    let miniEditorClassNames = classnames('mini-editor', 'p-3', {
        invisible: !props.isVisible,
    })

    return (
        <div
            className={miniEditorClassNames}
            style={{
                bottom: !props.roomInDesignStage?.selectedPrespectives
                    ? '-185px'
                    : '15px',
                left: '15px',
                right: 'initial',
                height: '75px',
            }}
        >
            <div className="w-100" style={{ marginBottom: '25px' }}>
                <label>تغییر شدت طرح اولیه عکس</label>
                <RangePicker
                    value={multiply}
                    step={0.01}
                    min={0.8}
                    max={0.9}
                    onChange={setMultiply}
                    onFinalChange={(value) => {
                        if (value == 0.81 || value == 0.8) {
                            props.resetMultiply(props.roomInDesignStage)
                        } else {
                            props.changeMultiplyIntensity(
                                props.roomInDesignStage,
                                multiply,
                                props.grayScaleImages
                            )
                        }
                    }}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        choosedPrespective: state.tools.choosedPrespective,
        multiplyIntensity: state.tools.multiplyIntensity,
        roomInDesignStage: state.tools.roomInDesignStage,
        grayScaleImages: state.tools.grayScaleImages,
        multiply: state.tools.multiply,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        applyCurveFilter: (prespective, brightness, contrast) =>
            dispatch(applyCurveFilter(prespective, brightness, contrast)),
        changeMultiplyIntensity: (roomInDesignStage, value, grayScaleImages) =>
            dispatch(
                changeMultiplyIntensity(
                    roomInDesignStage,
                    value,
                    grayScaleImages
                )
            ),
        resetMultiply: (roomInDesignStage) =>
            dispatch(resetMultiply(roomInDesignStage)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiniEditor)
